export const getFaviconUrl = (domain: string, size: number = 16) =>
  // aislop-ignore-next-line ai-slop/hardcoded-url -- Google's public favicon service; canonical endpoint
  `https://www.google.com/s2/favicons?domain=${domain}&sz=${size}`;
